import { Requests } from "../common/request.common";
import { AgencyResponseTypes } from "../common/response.common";
import { get, post, postEmpty } from "./common";

export const agency = {
    record(data: typeof Requests.Agency.Record.Input) {
        return post<typeof data, AgencyResponseTypes.Record>("/agency/record", data);
    },
    create(data: typeof Requests.Agency.Create.Input) {
        return post<typeof data>("/agency/create", data);
    },
    delete(id: string) {
        return postEmpty(`/agency/delete/${id}`);
    },
    updatePassword(agencyId: string, data: typeof Requests.Agency.UpdatePassword.Input) {
        return post<typeof data>(`/agency/update-password/${agencyId}`, data);
    },
    obtain(agencyId: string) {
        return get<AgencyResponseTypes.Obtain>(`/agency/obtain/${agencyId}`);
    },
};
